import type { WorkspaceDefinition } from '@/core/ui/workspace'
import { outboxDiagnosticsPermissions } from '@/modules/operations/outboxDiagnosticsOwners'

// docs/upgrade/06 §4 nhóm Hệ thống (đợt M4).
export const notificationSettingsWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'rules', labelKey: 'nav.notificationRules', icon: 'pi pi-sliders-h', permission: 'NotificationRules.Read', component: () => import('@/modules/notifications/NotificationRulesView.vue') },
    { key: 'occurrences', labelKey: 'nav.notificationOccurrences', icon: 'pi pi-history', permission: 'NotificationRules.Read',
      component: () => import('@/modules/notifications/NotificationOccurrenceView.vue') },
  ],
}

// ADR-078: Audit & sử dụng — tần suất sử dụng theo tài khoản; tab Nhật ký & chẩn đoán gộp nhật ký thao tác và chẩn đoán Outbox
// (13/10/2026: bỏ màn "Chẩn đoán hệ thống" riêng, /diagnostics chuyển hướng về đây).
const usage = () => import('@/modules/usage/UsageAnalyticsView.vue')
export const auditWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'usage', labelKey: 'usage.tabs.overview', icon: 'pi pi-chart-line', permission: 'AuditTrail.Read', component: usage, props: { mode: 'overview' } },
    { key: 'accounts', labelKey: 'usage.tabs.accounts', icon: 'pi pi-users', permission: 'AuditTrail.Read', component: usage, props: { mode: 'accounts' } },
    { key: 'log', labelKey: 'auditLog.title', icon: 'pi pi-list-check', permission: ['AuditTrail.Read', ...outboxDiagnosticsPermissions], permissionMode: 'any',
      component: () => import('@/modules/operations/AuditLogView.vue') },
  ],
}
